export default "__VITE_ASSET__M1gt79vJ__"